import {firebase} from '@firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'

var config = {
    apiKey: "AIzaSyCndTw8FJ57HNQMxtqNTXUojZVta-cmdi8",
    authDomain: "walt-boxed.firebaseapp.com",
    databaseURL: "https://walt-boxed.firebaseio.com",
    projectId: "walt-boxed",
    storageBucket: "walt-boxed.appspot.com",
    messagingSenderId: "639601834590"
}

!firebase.apps.length ? firebase.initializeApp(config) : ''
export const GoogleProvider = new firebase.auth.GoogleAuthProvider()
export const EmailProvider = new firebase.auth.EmailAuthProvider()
export const auth = firebase.auth()
export const db = firebase.firestore()
// db.settings({ timestampsInSnapshots: true })
export const functions = firebase.functions()
export const storage = firebase.storage()

// update the user document with the users display name and email when they link their anonymous account
firebase.auth().getRedirectResult().then(function(result) {
    if (result.credential) {
        /*
        var update = {
            display_name: result.user.providerData[0].displayName,
            email: result.user.providerData[0].email
        }
        */
        //firebase.firestore().collection('users').doc(result.user.uid).update(update)
    }
}).catch(function(error) {
    console.error(error)
})

export default firebase
